import {ScreenTypes} from "./screen-types";

export enum RouterLinks {
  Error404 = '404',
  CreateAccount = 'creer-mon-compte',
  Login = 'login',
  PasswordReminder = 'rappel-mdp',
  PasswordReset = 'reinitialisation-mdp',
  MyAccount = 'mon-espace-personnel',
  ModulesList = '',
  Module = 'module', // only used here
  ModuleIntro =  RouterLinks.Module + '/:uuid/' + ScreenTypes.Intro,
  Questions = RouterLinks.Module + '/:uuid/' + ScreenTypes.Question,
  ModuleExplanation = RouterLinks.Module + '/:uuid/' + ScreenTypes.Explanation,
  ModuleEnd = RouterLinks.Module + '/:uuid/' + ScreenTypes.End,
}
